import { useState } from "react";

import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  ITransactionsSummary,
  ITxOverview,
} from "../../../interfaces-and-types";
import { TSummaryPeriod } from "../../../constants";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

import { View } from "./View";

export interface IPaymentsSummaryViewProps extends ISummarySectionViewProps<ITxOverview> {}

export const PaymentsSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingTransactionsSummary,
    // isSuccess: isSuccessTransactionsSummary,
    // isError: isErrorTransactionsSummary,
    data: transactionsSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, ITransactionsSummary>(
    [
      "getTransactionsSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingTransactionsOverviewByPeriod,
    // isSuccess: isSuccessTransactionsOverviewByPeriod,
    // isError: isErrorTransactionsOverviewByPeriod,
    data: transactionsOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    ITxOverview
  >(
    [
      "getTransactionsOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? transactionsSummary?.today
      : summaryPeriod === "past week"
        ? transactionsSummary?.past_week
        : summaryPeriod === "past month"
          ? transactionsSummary?.past_month
          : summaryPeriod === "custom"
            ? transactionsOverviewByPeriod
            : transactionsSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingTransactionsOverviewByPeriod
      : isLoadingTransactionsSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
